export enum TdsDeductble {
    Yes = "Yes",
    No = "No",
   
}